 <template>
  <div v-loading="loading">
    <p class="mt-4 mb-2 font-semibold">
      You can activate the Virtual NUBAN Account, the Direct Debit or both to manage your payments.
    </p>
    <hr style="dotted">
    <div class="flex justify-between mt-12 mb-2">
      <div class="flex">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'virtual-nuban-accounts' }"
          @click="currentTab = 'virtual-nuban-accounts'"
        >
          <p>Virtual Nuban Account</p> 
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'direct-debit' }"
          @click="currentTab = 'direct-debit'"
        >
          <p>Direct Debit</p>
        </div>
      </div>
    </div>

    <hr />
    <keep-alive>
      <component :is="currentTab"></component>
    </keep-alive>
  </div>
</template>

<script>
// import Pagination from "@/components/UI/pagination";
import DirectDebit from "./Partials/DirectDebit";
import VirtualNubanAccounts from "./Partials/VirtualNubanAccounts";


export default {
  components: {
    DirectDebit,
    VirtualNubanAccounts,
  },
  data() {
    return {
      currentTab: "virtual-nuban-accounts",
      query: '',
      count: {},
      loading: false
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentBillingsTab", val);
    }
  },
  mounted() {
    const currentTab = this.$store.getters.currentBillingsTab;
    if (currentTab) {
      this.currentTab = currentTab;
    }
  },
};
</script>


<style lang="scss" scoped>
tr:first-child td:first-child { border-top-left-radius: 10px; }
tr:first-child td:last-child { border-top-right-radius: 10px; }
tr:last-child td:first-child { border-bottom-left-radius: 10px; }
tr:last-child td:last-child { border-bottom-right-radius: 10px; }
.table__search-input-wrapper {  
  background: #7B858F10;
  width: 20vw;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #FCC210;
    font-weight: bold;
  }
}
</style>
